module.exports = "pegasus/assets/blocks/header-8-theme4.png";